import ApiService from "@/core/services/api.service";
// action types
export const GET_ALL = "getAll";

export default {
  state: {
    path: "banner"
  },
  getters: {},
  actions: {
    [GET_ALL](context) {
      ApiService.setHeader();
      return ApiService.getParams(context.state.path, null);
    }
  },
  mutations: {}
};